
import { useState } from 'react';

export default function Contact() {
  const [formData] = useState({
    name: '',
    organization: '',
    email: '',
    phone: '',
    message: '',
    contactMethod: 'email',
    services: [] as string[]
  });

  const serviceOptions = [
    'Full-Service Bookkeeping',
    'Financial Management & Reporting',
    'Payroll & Advisory Support'
  ];

  return (
    <section id="contact" className="py-24 bg-warm-50 relative overflow-hidden">
      <div className="absolute top-0 right-0 w-80 h-80 bg-[#059669]/5 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2"></div>
      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative">
        <div className="text-center mb-16">
          <span className="inline-block text-[#059669] text-sm font-semibold tracking-widest uppercase mb-4">Get In Touch</span>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900" style={{ fontFamily: "'EB Garamond', 'Times New Roman', serif" }}>
            Let&apos;s Talk About Your Books
          </h2>
        </div>

        <div className="grid lg:grid-cols-5 gap-12">
          <div className="lg:col-span-2">
            <p className="text-base text-gray-600 leading-relaxed mb-10">
              Whether you need ongoing bookkeeping or help untangling your current records, we&apos;re here to help. Share a bit about your organization, and we&apos;ll follow up to discuss next steps.
            </p>

            <div className="space-y-6">
              <div className="flex items-start space-x-4 group">
                <div className="w-12 h-12 flex items-center justify-center bg-[#612c42]/8 rounded-lg flex-shrink-0 group-hover:bg-[#612c42] transition-colors duration-300">
                  <i className="ri-map-pin-line text-xl text-[#612c42] group-hover:text-white transition-colors duration-300"></i>
                </div>
                <div>
                  <h3 className="text-sm font-semibold text-gray-900 mb-1">Address</h3>
                  <p className="text-sm text-gray-500 leading-relaxed">
                    2415 San Ramon Valley Blvd, Ste 4229<br />
                    San Ramon, CA 94583
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4 group">
                <div className="w-12 h-12 flex items-center justify-center bg-[#612c42]/8 rounded-lg flex-shrink-0 group-hover:bg-[#612c42] transition-colors duration-300">
                  <i className="ri-phone-line text-xl text-[#612c42] group-hover:text-white transition-colors duration-300"></i>
                </div>
                <div>
                  <h3 className="text-sm font-semibold text-gray-900 mb-1">Phone</h3>
                  <a href="tel:5103503216" className="text-sm text-gray-500 hover:text-[#612c42] transition-colors">(510) 350-3216</a>
                </div>
              </div>

              <div className="flex items-start space-x-4 group">
                <div className="w-12 h-12 flex items-center justify-center bg-[#612c42]/8 rounded-lg flex-shrink-0 group-hover:bg-[#612c42] transition-colors duration-300">
                  <i className="ri-mail-line text-xl text-[#612c42] group-hover:text-white transition-colors duration-300"></i>
                </div>
                <div>
                  <h3 className="text-sm font-semibold text-gray-900 mb-1">Email</h3>
                  <p className="text-sm text-gray-500">bps.antonia@gmail.com</p>
                </div>
              </div>

              <div className="flex items-start space-x-4 group">
                <div className="w-12 h-12 flex items-center justify-center bg-[#612c42]/8 rounded-lg flex-shrink-0 group-hover:bg-[#612c42] transition-colors duration-300">
                  <i className="ri-time-line text-xl text-[#612c42] group-hover:text-white transition-colors duration-300"></i>
                </div>
                <div>
                  <h3 className="text-sm font-semibold text-gray-900 mb-1">Business Hours</h3>
                  <p className="text-sm text-gray-500">Monday - Friday: 9:00 AM - 5:00 PM</p>
                </div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-3">
            <div className="bg-white p-8 rounded-lg shadow-sm border border-gray-100 relative">

              {/* Coming Soon Overlay */}
              <div className="absolute inset-0 z-10 rounded-lg bg-white/80 backdrop-blur-sm flex flex-col items-center justify-center">
                <div className="bg-[#612c42] text-white px-8 py-5 rounded-lg shadow-xl text-center">
                  <div className="w-12 h-12 flex items-center justify-center mx-auto mb-3 bg-white/20 rounded-full">
                    <i className="ri-time-line text-2xl text-white"></i>
                  </div>
                  <p className="text-xl font-bold tracking-wide" style={{ fontFamily: "'EB Garamond', serif" }}>Coming Soon</p>
                  <p className="text-sm text-white/80 mt-1">Request form will be available shortly.</p>
                </div>
              </div>

              {/* Disabled Form (visible beneath overlay) */}
              <h3 className="text-2xl font-bold text-gray-900 mb-6" style={{ fontFamily: "'EB Garamond', serif" }}>Submit Your Request Here</h3>
              <div className="space-y-5 pointer-events-none select-none opacity-40">
                <div className="grid md:grid-cols-2 gap-5">
                  <div>
                    <label className="block text-xs font-semibold text-gray-700 mb-2 uppercase tracking-wide">Name *</label>
                    <input
                      type="text"
                      disabled
                      value={formData.name}
                      className="w-full px-4 py-3 text-sm border border-gray-200 rounded-md bg-gray-50/50 cursor-not-allowed"
                      placeholder="Your full name"
                    />
                  </div>
                  <div>
                    <label className="block text-xs font-semibold text-gray-700 mb-2 uppercase tracking-wide">Organization *</label>
                    <input
                      type="text"
                      disabled
                      value={formData.organization}
                      className="w-full px-4 py-3 text-sm border border-gray-200 rounded-md bg-gray-50/50 cursor-not-allowed"
                      placeholder="Your company or organization"
                    />
                  </div>
                </div>

                <div className="grid md:grid-cols-2 gap-5">
                  <div>
                    <label className="block text-xs font-semibold text-gray-700 mb-2 uppercase tracking-wide">Email *</label>
                    <input
                      type="email"
                      disabled
                      value={formData.email}
                      className="w-full px-4 py-3 text-sm border border-gray-200 rounded-md bg-gray-50/50 cursor-not-allowed"
                      placeholder="your@email.com"
                    />
                  </div>
                  <div>
                    <label className="block text-xs font-semibold text-gray-700 mb-2 uppercase tracking-wide">Phone *</label>
                    <input
                      type="tel"
                      disabled
                      value={formData.phone}
                      className="w-full px-4 py-3 text-sm border border-gray-200 rounded-md bg-gray-50/50 cursor-not-allowed"
                      placeholder="(510) 350-3216"
                    />
                  </div>
                </div>

                <div>
                  <label className="block text-xs font-semibold text-gray-700 mb-3 uppercase tracking-wide">Services Interested In</label>
                  <div className="space-y-2">
                    {serviceOptions.map((service) => (
                      <label key={service} className="flex items-center space-x-3">
                        <div className="w-5 h-5 rounded border-2 border-gray-300 bg-white flex items-center justify-center flex-shrink-0"></div>
                        <span className="text-sm text-gray-700">{service}</span>
                      </label>
                    ))}
                  </div>
                </div>

                <div>
                  <label className="block text-xs font-semibold text-gray-700 mb-2 uppercase tracking-wide">How can we help? *</label>
                  <textarea
                    disabled
                    rows={4}
                    className="w-full px-4 py-3 text-sm border border-gray-200 rounded-md bg-gray-50/50 resize-none cursor-not-allowed"
                    placeholder="Tell us about your bookkeeping needs..."
                  ></textarea>
                </div>

                <div>
                  <label className="block text-xs font-semibold text-gray-700 mb-2 uppercase tracking-wide">Preferred contact method *</label>
                  <select
                    disabled
                    className="w-full px-4 py-3 text-sm border border-gray-200 rounded-md bg-gray-50/50 cursor-not-allowed"
                  >
                    <option value="email">Email</option>
                  </select>
                </div>

                <button
                  disabled
                  className="w-full bg-[#612c42]/50 text-white px-6 py-4 rounded-md text-sm font-bold cursor-not-allowed whitespace-nowrap shadow-md"
                >
                  Send Request
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
